export default __webpack_public_path__ + "static/media/p05 p01.092cbf0a.jpg";